<template>
    <div>
    <div class="p-5 w-full h-48 relative cursor-pointer">
        <FolderTop class="absolute left-0 top-0 z-0 w-full h-full text-folderTopBlue"/>
        <div class="absolute right-0 top-4 z-20 hover:bg-smoke p-1 rounded-xl" @click.stop="showFolderOptions = !showFolderOptions">
            <DotsHorizontal class="text-yank opacity-50"/>
        </div>
        <div v-if="showFolderOptions" v-on-clickaway="away" class="absolute w-40 h-30 top-8 bg-white z-50 rounded-xl">
            <div class="p-2 flex flex-row items-center justify-start hover:bg-smoke rounded-t-xl" @click="openManageFolderModal">
                <EditIcon class="mr-2 w-3 h-3 text-yank opacity-40"/>
                <p class="text-xs text-yank">Rename</p>
            </div>
            <div class="p-2 flex flex-row items-center justify-start hover:bg-smoke rounded-b-xl" @click="openDeleteFolderModal">
                <TrashIcon class="mr-2 w-3 h-3 text-yank opacity-40"/>
                <p class="text-xs text-yank">Delete</p>
            </div>
        </div>
        <div @click="$emit('open', folder.id)" class="cursor-pointer">
        <div class="absolute h-40 w-full z-10 bottom-0 left-0 bg-folderBlue rounded-tr-xl rounded-b-xl flex flex-col items-center justify-center">
            <div class="m-auto grid grid-cols-2 gap-2 absolute top-3">
                <div v-for="item in getFirstThreeItems()" :key="item.id" class="w-16 h-16 object-cover rounded-lg">
                    <img v-if="!includesVideo(item)" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" :src="item.thumbnail_url" loading="lazy" :alt="item.name" class="w-16 h-16 object-cover rounded-lg"/>
                    <video
                        ref="video"
                        v-else
                        class="w-16 h-16 object-cover rounded-lg"
                        muted
                        loop
                        >
                        <source :src="item.thumbnail_url" :type="item.mime_type">
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div v-if="getFourthItem()" class="w-16 h-16 relative">
                    <img v-if="!includesVideo(getFourthItem())" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" :src="getFourthItem().thumbnail_url" loading="lazy" :alt="getFourthItem().name" class="w-16 h-16 object-cover rounded-lg" :class="folder.items.length > 4 ? 'opacity-50' : ''"/>
                    <video
                        ref="video"
                        v-else
                        :class="folder.items.length > 4 ? 'opacity-50' : ''"
                        class="w-16 h-16 object-cover rounded-lg"
                        muted
                        loop
                        >
                        <source :src="getFourthItem().thumbnail_url" :type="getFourthItem().mime_type">
                        Your browser does not support the video tag.
                    </video>
                    <div v-if="folder.items.length > 4" class="absolute w-full h-full top-5 left-3 text-white">+ {{folder.items.length - 4 }}</div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <p class="text-center w-full text-sm text-payne mt-2">{{ folder.name }}</p>
    </div>
</template>

<script>
  import FolderTop from '@/components/svg/FolderTop.vue'
  import DotsHorizontal from '@/components/svg/DotsHorizontal'
  import EditIcon from '@/components/svg/EditIcon'
  import TrashIcon from '@/components/svg/TrashIcon'
  import {mixin as clickaway} from 'vue-clickaway'
  import { IMAGE_PLACEHOLDER } from '@/utils/constants';

  export default {
    name: 'Folder',

    mixins: [clickaway],

    remember: ['folderItems'],

    data(){
        return{
            showFolderOptions:false,
            ManageFolderModalOpen: false,
            IMAGE_PLACEHOLDER
        }
    },

    props: {
        folder:{ type: Object, required: true}
    },

    components: {
        FolderTop,
        DotsHorizontal,
        EditIcon,
        TrashIcon,
    },

    methods: {
        getFirstThreeItems(){
            return (this.folder.items && this.folder.items.length && this.folder.items.length > 3) ? this.folder.items.slice(0,3) : this.folder.items
        },

        includesVideo(item) {
            return item && item.mime_type.includes('video');
        },

        getFourthItem(){
            return (this.folder.items && this.folder.items.length && this.folder.items.length >= 4) ? this.folder.items[3] : null
        },

        away(){
            this.showFolderOptions = false;
        },

        openManageFolderModal(){
            this.$emit('openRenameModal', this.folder)
        },

        openDeleteFolderModal(){
            this.$emit('openDeleteModal', this.folder)
        },
    }

  }
</script>
